import React from "react";
import { Stack } from "@mui/material";

import ContactsLocationFilter from "../../pages/Companies/ContactsLocationFilter";
import { DialogButton } from "../../components";

const OrganizationPermissionsBar = () => {
  return (
    <Stack direction="row" gap="10px" justifyContent="space-between">
      <ContactsLocationFilter />
      <DialogButton
        name="create-role"
        label="Create Role"
        variant="contained"
        size="xsmall"
      />
    </Stack>
  );
};

export default OrganizationPermissionsBar;
